/**
 * toggleActive creates the on click listener for '.js-toggle-active'.
 *
 * The on click listener toggles the class 'is-active' on itself.
 */

function toggleActive() {
	$(document).on('click', '.js-toggle-active', function() {
		$(this).toggleClass('is-active');
	});
}
toggleActive();
